import * as React from 'react';
import Markdown from 'markdown-to-jsx';
import { CTA } from '../call-to-action';
import { List, ListItem } from '../list';
import { Text, TextTag, TokenTextAppearance } from '../text';
import { getCommonProps } from '../helpers/common-props';
const { headline500, headline400, headline200, headline100, copy200 } = TokenTextAppearance;
const { div, h1, h2, h3, h4, strong, p, span } = TextTag;
const allowedHTMLTags = [
    'a',
    'b',
    'br',
    'div',
    'em',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'i',
    'li',
    'ol',
    'p',
    'span',
    'strong',
    'sub',
    'sup',
    'table',
    'tbody',
    'thead',
    'td',
    'th',
    'tr',
    'u',
    'ul',
];
export function createTagOverride(component, props) {
    return props ? { component, props } : { component };
}
// wrapper for CTA to handle required href prop
export const RichtextLink = (props) => (React.createElement(CTA, Object.assign({}, props, { href: (props && props.href) || '#', tag: "a", emphasis: "tertiary" })));
const createDefaultMdOverrides = (color) => ({
    h1: createTagOverride(Text, {
        tag: h1,
        appearance: headline500,
        color,
    }),
    h2: createTagOverride(Text, {
        tag: h2,
        appearance: headline400,
        color,
    }),
    h3: createTagOverride(Text, {
        tag: h3,
        appearance: headline200,
        color,
    }),
    h4: createTagOverride(Text, {
        tag: h4,
        appearance: headline100,
        color,
    }),
    p: createTagOverride(Text, {
        tag: p,
        appearance: copy200,
        color,
    }),
    span: createTagOverride(Text, {
        tag: span,
        appearance: copy200,
        color,
    }),
    div: createTagOverride(Text, {
        tag: div,
        appearance: copy200,
        color,
    }),
    strong: createTagOverride(Text, { tag: strong, bold: true, color }),
    a: createTagOverride(RichtextLink),
    ul: createTagOverride(List),
    ol: createTagOverride(List, { isOrdered: true }),
    li: createTagOverride(ListItem),
});
export const Richtext = (props) => {
    const { markdown, overrides = {}, color, dangerouslyParseRawHTML } = props;
    const commonProps = getCommonProps(props);
    const mdOptions = {
        disableParsingRawHTML: dangerouslyParseRawHTML ? false : true,
        overrides: Object.assign(Object.assign({}, createDefaultMdOverrides(color)), overrides),
        createElement(type, _elementProps, children) {
            if (typeof type === 'string' && !allowedHTMLTags.includes(type)) {
                return React.createElement(React.Fragment, null, children);
            }
            // I'd rather pass type, elementProps, and children as normal arguments to React.createElement, but somehow that breaks tables somewhere deep in markdown-to-jsx. ¯\_(ツ)_/¯
            // eslint-disable-next-line prefer-rest-params, @typescript-eslint/no-explicit-any -- prevent markdown-to-jsx from breaking tables. Don't do this elsewhere.
            return React.createElement.apply(this, arguments);
        },
        wrapper: React.Fragment,
        forceWrapper: true,
    };
    return (React.createElement(Markdown, Object.assign({ options: mdOptions }, commonProps), markdown));
};
